<hb-modal-dialog [heading]="title" [showCancel]="true">
  <div *ngIf="selectedFailureEffect?.commercialImpacts" content>
    <hb-commercial-impacts
      [form]="form"
      [impacts]="selectedFailureEffect.commercialImpacts"
      [isReadOnly]="isReadOnly"
      totalHeader="{{ 'FailureEffectCommercialImpactDialog.Failure' | i18next }}"
    ></hb-commercial-impacts>
  </div>
</hb-modal-dialog>
